// Needed to support async await
import 'regenerator-runtime/runtime'
import App from './App'
import render from 'commons/js/util/render'
import { init } from 'commons/js/util/reporter'

init()

const element = document.querySelector('.js-searcher')
const dataset = element.dataset

const dataProps = {
    items: JSON.parse(dataset.items),
    title: dataset.title,
    placeholder: dataset.placeholder,
    minLengthSearch: parseInt(dataset.minLengthSearch),
}

render({ App, element, props: { ...dataProps } })
